import Api from '@/services/Api' // axois object created in api.js
import { Period } from '../types'
export default { // export its register method
  calculate ({
    programIds,
    organizationIds,
    organizationGroupIds,
    periods,
    getFinalizedLessonValue,
    getOrganizationIncome,
    getHostIncome,
    getPlatformIncome,
    getManagerIncome,
    getTrainerIncome,
    getTutorIncome,
    getInviterIncome,
    adjustForUserFeePayment
  }: {
    programIds: number[];
    organizationIds: number[];
    organizationGroupIds: number[];
    periods: Period[];
    getFinalizedLessonValue: boolean;
    getOrganizationIncome: boolean;
    getHostIncome: boolean;
    getPlatformIncome: boolean;
    getManagerIncome: boolean;
    getTrainerIncome: boolean;
    getTutorIncome: boolean;
    getInviterIncome: boolean;
    adjustForUserFeePayment: boolean;
  }) {
    console.log('[StatisticsService calculate] request send, waiting ...')
    return Api().post('statistics/lesson-value-distribution', {
      programIds,
      organizationIds,
      organizationGroupIds,
      periods,
      getFinalizedLessonValue,
      getOrganizationIncome,
      getTutorIncome,
      getHostIncome,
      getPlatformIncome,
      getManagerIncome,
      getTrainerIncome,
      getInviterIncome,
      adjustForUserFeePayment
    })
  },
  payablesSnapshot ({
    userIds
  }: {
    userIds: null | number[];
  }) {
    console.log('[StatisticsService payablesSnapshot] request send, waiting ...')
    return Api().get('statistics/payables', {
      params: {
        userIds
      }
    })
  }
}
